import { Grid } from "@mantine/core"


const MantineGridColumn = ({ span, children, className, order }: any) => {
    return <Grid.Col span={span} className={className} order={order}>{children}</Grid.Col>;
};


const MantineGrid = (props: any) => {
    const { gutter, grow, justify, align, columns, overflow, className, p, key} = props
    return (
        <Grid
            gutter={gutter}
            grow={grow || false}
            justify={justify}
            align={align}
            columns={columns}
            overflow={overflow}
            className={className}
            key={key}
            p={p}
        >
            {props.children}
        </Grid>
    )
}
export { MantineGrid, MantineGridColumn };